<template>
<b-dropdown right>
  <template slot="button-content">
      <span>{{this.checkOrder}}</span>
  </template>
  <b-dropdown-item @click="selected({targetKey: 'createdAt', isDesc: true})">{{$t('registerDescending')}}</b-dropdown-item>
  <b-dropdown-item @click="selected({targetKey: 'createdAt', isDesc: false})">{{$t('registerAscending')}}</b-dropdown-item>
  <b-dropdown-item @click="selected({targetKey: 'modifiedAt', isDesc: true})">{{$t('updateDescending')}}</b-dropdown-item>
  <b-dropdown-item @click="selected({targetKey: 'modifiedAt', isDesc: false})">{{$t('updateAscending')}}</b-dropdown-item>
</b-dropdown>
</template>

<script>

export default {
  name: 'SelectDropDown',
  props: {
    order: Object
  },
  computed: {
    getOrder: function () {
      return this.order
    },
    checkOrder: function () {
      if (this.order.targetKey === 'createdAt' && this.order.isDesc === true) return this.$t('registerDescending')
      else if (this.order.targetKey === 'createdAt' && this.order.isDesc === false) return this.$t('registerAscending')
      else if (this.order.targetKey === 'modifiedAt' && this.order.isDesc === true) return this.$t('updateDescending')
      else if (this.order.targetKey === 'modifiedAt' && this.order.isDesc === false) return this.$t('updateAscending')
      else return this.$t('okrMenuTitleType')
    }
  },
  methods: {
    selected: function (value) {
      this.$emit('set-selected-order', value)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Okr/SelectDropDown.vue